import Moment from 'moment';


export const ConvertUtcToDate=(value:Date)=>{
    if(value)
     return Moment(value).toDate() 
}

